module.exports = __webpack_public_path__ + "static/media/CI.dac3e5a4.svg";